<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="computedDateFormatted"
          placeholder="Выберите дату"
          clearable
          outlined
          rounded
          dense
          append-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          :error-messages="errorMessages"
        >
          <template #label>
            <span :class="{ 'required': required }">{{label}}</span>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        :disabled="disabled"
        locale="ru"
        first-day-of-week="1"
        no-title
        @input="menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { getIsoDate, getFormatDate } from "@/scripts/formatDate";

export default {
  name: "DatePicker",

  props: {
    label: String,
    propDate: String,
    errorMessages: String,
    required: Boolean,
    disabled: Boolean
  },

  data: () => ({
    date: '',
    menu: false
  }),

  computed: {
    computedDateFormatted: {
      get() {
        return getFormatDate(this.date)
      },
      set(value) {
        this.date = value
      }
    }
  },

  methods: {},

  watch: {
    propDate: {
      immediate: true,
      handler(value) {
        this.date = getIsoDate(value)
      }
    },

    date(value) {
      if (value !== getIsoDate(this.propDate)) {
        const date = value ? getFormatDate(value) : value
        this.$emit('set-date', date)
      }
    }
  }
}
</script>

<style scoped>

</style>
